/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Timeline_Legacy_Zoom_Seconds_Aria_LabelInputs */

const en_timeline_legacy_zoom_seconds_aria_label = /** @type {(inputs: Timeline_Legacy_Zoom_Seconds_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zoom to ${i?.seconds} seconds`)
};

const fr_timeline_legacy_zoom_seconds_aria_label = /** @type {(inputs: Timeline_Legacy_Zoom_Seconds_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zoomer a ${i?.seconds} secondes`)
};

const de_timeline_legacy_zoom_seconds_aria_label = /** @type {(inputs: Timeline_Legacy_Zoom_Seconds_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zoom auf ${i?.seconds} Sekunden`)
};

const it_timeline_legacy_zoom_seconds_aria_label = /** @type {(inputs: Timeline_Legacy_Zoom_Seconds_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zoom a ${i?.seconds} secondi`)
};

const ru_timeline_legacy_zoom_seconds_aria_label = /** @type {(inputs: Timeline_Legacy_Zoom_Seconds_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Увеличить до ${i?.seconds} секунд`)
};

const es_timeline_legacy_zoom_seconds_aria_label = /** @type {(inputs: Timeline_Legacy_Zoom_Seconds_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zoom a ${i?.seconds} segundos`)
};

const zh_cn2_timeline_legacy_zoom_seconds_aria_label = /** @type {(inputs: Timeline_Legacy_Zoom_Seconds_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`放大至 ${i?.seconds} 秒`)
};

const ja_timeline_legacy_zoom_seconds_aria_label = /** @type {(inputs: Timeline_Legacy_Zoom_Seconds_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} 秒にズーム`)
};

const hi_timeline_legacy_zoom_seconds_aria_label = /** @type {(inputs: Timeline_Legacy_Zoom_Seconds_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} सेकंड पर ज़ूम करें`)
};

const pt_pt2_timeline_legacy_zoom_seconds_aria_label = /** @type {(inputs: Timeline_Legacy_Zoom_Seconds_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ampliar para ${i?.seconds} segundos`)
};

/**
* | output |
* | --- |
* | "Zoom to {seconds} seconds" |
*
* @param {Timeline_Legacy_Zoom_Seconds_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_legacy_zoom_seconds_aria_label = /** @type {((inputs: Timeline_Legacy_Zoom_Seconds_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Legacy_Zoom_Seconds_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timeline_legacy_zoom_seconds_aria_label(inputs)
	if (locale === "de") return de_timeline_legacy_zoom_seconds_aria_label(inputs)
	if (locale === "it") return it_timeline_legacy_zoom_seconds_aria_label(inputs)
	if (locale === "ru") return ru_timeline_legacy_zoom_seconds_aria_label(inputs)
	if (locale === "es") return es_timeline_legacy_zoom_seconds_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_timeline_legacy_zoom_seconds_aria_label(inputs)
	if (locale === "ja") return ja_timeline_legacy_zoom_seconds_aria_label(inputs)
	if (locale === "hi") return hi_timeline_legacy_zoom_seconds_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_timeline_legacy_zoom_seconds_aria_label(inputs)
	return en_timeline_legacy_zoom_seconds_aria_label(inputs)
});